var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.3283 15.3031L10.3283 15.3031L10.325 15.306C10.1095 15.5017 9.77508 15.5014 9.55965 15.303L9.55966 15.3029L9.55484 15.2986L9.46836 15.2199L9.46659 15.2183C7.38171 13.332 5.74364 11.845 4.62642 10.4601C3.5238 9.09334 3.03304 7.95033 3.07253 6.76354C3.10913 5.73447 3.63955 4.752 4.47577 4.18266L4.47632 4.18229C6.06811 3.09698 8.07175 3.57868 9.17547 4.87053L9.93576 5.76042L10.6961 4.87053C11.8019 3.57626 13.8044 3.09161 15.3931 4.18084L15.3958 4.18266C16.2322 4.75216 16.7627 5.73502 16.799 6.76441L16.7991 6.7652C16.8418 7.9505 16.3522 9.09267 15.2479 10.4623C14.1295 11.8493 12.49 13.3397 10.4051 15.234C10.4045 15.2345 10.4039 15.235 10.4034 15.2355L10.3283 15.3031Z"}));
}

Heart.defaultProps = {"width":"20","height":"19","viewBox":"0 0 20 19","fill":"none"};

module.exports = Heart;

Heart.default = Heart;
